///mastersystemserver/list
export const MASTER_SYSTEM_SERVER_LIST = "MASTER_SYSTEM_SERVER_LIST";
export const MASTER_SYSTEM_SERVER_LIST_SUCCESS =
  "MASTER_SYSTEM_SERVER_LIST_SUCCESS";
export const MASTER_SYSTEM_SERVER_LIST_FAILURE =
  "MASTER_SYSTEM_SERVER_LIST_FAILURE";
///mastersystemserver/deploy/:id
export const MASTER_SYSTEM_SERVER_DEPLOY = "MASTER_SYSTEM_SERVER_DEPLOY";
export const MASTER_SYSTEM_SERVER_DEPLOY_SUCCESS =
  "MASTER_SYSTEM_SERVER_DEPLOY_SUCCESS";
export const MASTER_SYSTEM_SERVER_DEPLOY_FAILURE =
  "MASTER_SYSTEM_SERVER_DEPLOY_FAILURE";
